import { useCallback, useEffect, useRef, useState, type MouseEvent, type SyntheticEvent } from 'react'
import { analytics } from '../../../lib/analytics'

const phases = [
  { id: 'inhale', label: 'Вдох', hint: 'медленно через нос', seconds: 4 },
  { id: 'hold', label: 'Пауза', hint: 'мягко задержите дыхание', seconds: 4 },
  { id: 'exhale', label: 'Выдох', hint: 'долго, через рот', seconds: 6 },
] as const

export function useSos() {
  const [open, setOpen] = useState(false)
  const openPractice = useCallback(() => { analytics.track('sosClicked'); setOpen(true) }, [])
  const closePractice = useCallback(() => setOpen(false), [])
  return { open, openPractice, closePractice }
}

export function useBreathingPractice(onClose: () => void) {
  const [step, setStep] = useState(0)
  const phase = phases[step % phases.length]
  const cycle = Math.floor(step / phases.length) + 1
  const dialogRef = useRef<HTMLDialogElement>(null)

  useEffect(() => {
    const timer = window.setTimeout(() => setStep((value) => value + 1), phase.seconds * 1000)
    return () => window.clearTimeout(timer)
  }, [step, phase.seconds])

  useEffect(() => {
    const dialog = dialogRef.current
    dialog?.showModal()
    return () => dialog?.close()
  }, [])

  const closePractice = () => {
    // Close while the dialog is still mounted so the browser restores focus.
    dialogRef.current?.close()
    onClose()
  }
  const cancelPractice = (event: SyntheticEvent<HTMLDialogElement>) => {
    event.preventDefault()
    closePractice()
  }
  const closeOnBackdrop = (event: MouseEvent<HTMLDialogElement>) => {
    if (event.target === event.currentTarget) closePractice()
  }
  return { phase, cycle, step, dialogRef, closePractice, cancelPractice, closeOnBackdrop }
}
